export const ROUTE_PATHS = {
  // HOME: '/',
  LOGIN: '/login',
  AGENT: '/',
  EDIT_AGENT: '/edit-agent',
  CREATE_AGENT: '/create-agent',
  LOGIN_LINKEDIN: '/login-linkedin',
  LOGIN_TWITTER: '/login-twitter',
  LOGIN_GOOGLE: '/login-google',
  LOGIN_MICROSOFT: '/login-microsoft',
  LOGIN_APPLE: '/login-apple',
  LOGIN_FACEBOOK: '/login-facebook',
  DATATAG: '/data-tag',
  CUSTOMER_ACCOUNTS: '/customer-accounts',
  CREATE_CUSTOMER_ACCOUNTS: '/customer-details',
  IMPORT_USER: '/import-user',
  CHATBOT_WIDGET: '/chatbot-widget',
  CHATTING: '/chatting',
  CONVERSATION_HISTORY: '/conversation-history',
  CHATBOT_SETTINGS: '/chatbot-settings',
  TNC: '/terms-and-conditions',
  PRIVACY_POLICY: '/privacy-policy',
};

export const LOCAL_STORAGE = {
  LANGUAGE: 'Evol_studio_Language',
  ACCESS_TOKEN: 'Evol_studio_ACCESS_TOKEN',
  REFRESH_TOKEN: 'Evol_studio_REFRESH_TOKEN',
  SOCIAL_PKCE_UUID: 'Evol_studio_SOCIAL_PKCE_UUID',
  SOCIAL_PKCE_STATE: 'Evol_studio_SOCIAL_PKCE_STATE',
};

export const LOCAL_STORAGE_CHATBOT = {
  BOTKEY: 'Evol_studio_BOTKEY',
  ACCESSTOKEN_CHATBOT: 'Evol_studio_ACCESSTOKEN_CHATBOT',
  REFRESHTOKEN_CHATBOT: 'Evol_studio_REFRESHTOKEN_CHATBOT',
  ROLE: 'Evol_studio_ROLE',
  CONVERSATION_CODE: 'Evol_studio_CONVERSATION_CODE',
  VERIFIED: 'Evol_studio_VERIFIED',

  TEST_ROLE: 'Evol_studio_TEST_ROLE',
  TEST_VERIFIED: 'Evol_studio_TEST_VERIFIED',
};

export const SOCIAL_LOGIN_HOST = {
  GOOGLE: 'https://accounts.google.com/o/oauth2/v2/auth',
  TWITTER: 'https://twitter.com/i/oauth2/authorize',
  LINKEDIN: 'https://www.linkedin.com/oauth/v2/authorization',
  MICROSOFT: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize',
  FACEBOOK: 'https://www.facebook.com/v20.0/dialog/oauth',
  APPLE: 'https://appleid.apple.com/auth/authorize',
};

export const URL_CONST = {
  FILE_UPLOAD_CHUNK: 'api/v1/files/upload-chunk',
  FILE_MERGE_CHUNK: 'api/v1/files/merge-chunk',
};

export const MAX_SIZE_UPLOAD = 15728640; // 15MB
export const PAGE_SIZE = 10;

export const allowedExtensions = [
  'epub',
  'rtf',
  'txt',
  'csv',
  'tsv',
  'docx',
  'doc',
  'odt',
  'pdf',
  'xlsx',
  'ods',
  'pptx',
  'odp',
  'md',
  'xls',
  'ppt',
];
export const allowedImageExtensions = ['jpg', 'png', 'jpeg'];

export const INVALID_FILES = {
  NOT_SUPPORTED_TYPE: 'NOT_SUPPORTED_TYPE',
  MAX_SIZE_UPLOAD: 'MAX_SIZE_UPLOAD',
  ERROR_UPLOAD: 'ERROR_UPLOAD',
};

export const KNOWLEDGE_STATUS = {
  TRAINED: 'trained',
  PROCESSING: 'processing',
  ERROR: 'error',
};

export const CrawLinks = [
  {
    label: 'All page',
    value: 1,
  },
  {
    label: 'Sitemap',
    value: 3,
  },
];

export const DAYOFWEEK = {
  MON: 1,
  TUE: 2,
  WED: 3,
  THU: 4,
  FRI: 5,
  SAT: 6,
  SUN: 0,
};

export const TAG_STATUS = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  DEFAULT: 'default',
};

export const AGENT_TYPE = {
  ANONYMOUS: 3,
  VERIFIED: 2,
  BOTH: 1,
};

export const AUTHENTICATION_TYPE = {
  SINGLE_SIGN_ON: 1,
  SMS_OTP: 2,
  EMAIL_OTP: 3,
};

export const NAME_AUTHENTICATION_TYPE = {
  [AUTHENTICATION_TYPE.SINGLE_SIGN_ON]: '',
  [AUTHENTICATION_TYPE.SMS_OTP]: 'sms',
  [AUTHENTICATION_TYPE.EMAIL_OTP]: 'mail',
};

export const ERR_UPLOAD_RES = {
  inValidSize: 'invalid size'
};

export type StatusConnectType = 'connecting' | 'connected' | 'disconnected';

export const contractTypeOptions = [
  {
    label: 'Part time',
    value: 1
  },
  {
    label: 'HDGV',
    value: 2
  }
];

export const NoTaxCode = {
  label: 'Chưa có mã số thuế',
  value: 'Chưa có mã số thuế'
};
